(function () {
  'use strict';

  var CFG = {
    breakpoint: 900,
    mouseWidth: 116,
    restGap: 28,
    cableInset: 8,
    edgePad: 20,
    reducedMs: 180,
    maxRotation: 22,
    frameMs: 16.6667,
    cableLength: 58,
    physics: {
      gravityY: 0.95,
      gravityScale: 0.0015,
      bodyAir: 0.065,
      bodyDensity: 0.0075,
      anchorStiffness: 0.0038,
      anchorDamping: 0.065,
      dragStiffness: 0.03,
      dragDamping: 0.28,
      centerForce: 0.00011,
      dragCenterForce: 0.000014,
      pointerLift: 0.000009,
      maxReleaseVelocity: 11.5,
      pointerFollow: 0.24
    },
    settle: { speed: 0.18, distance: 1.2, angle: 0.2, angleVelocity: 0.03 },
    angle: { pull: 0.15, damping: 0.84 }
  };

  function clamp(value, min, max) {
    return value < min ? min : value > max ? max : value;
  }

  function cubicBezierApprox(t, p1x, p1y, p2x, p2y) {
    var cx = 3 * p1x;
    var bx = 3 * (p2x - p1x) - cx;
    var ax = 1 - cx - bx;
    var cy = 3 * p1y;
    var by = 3 * (p2y - p1y) - cy;
    var ay = 1 - cy - by;
    var u = t;
    var i;
    for (i = 0; i < 8; i++) {
      var xu = ((ax * u + bx) * u + cx) * u - t;
      var dxu = (3 * ax * u + 2 * bx) * u + cx;
      if (Math.abs(dxu) < 1e-6) break;
      u -= xu / dxu;
    }
    u = clamp(u, 0, 1);
    return ((ay * u + by) * u + cy) * u;
  }

  function easeRetract(t) {
    return cubicBezierApprox(t, 0.33, 1, 0.68, 1);
  }

  function createLayout() {
    return {
      handleH: 0,
      anchorX: 0,
      anchorY: 0,
      restX: 0,
      restTopY: 0,
      restCenterY: 0,
      boundsL: 0,
      boundsR: 0,
      boundsTop: 0,
      boundsBottom: 0,
      boundsCenterTop: 0,
      boundsCenterBottom: 0
    };
  }

  function createDragState() {
    return {
      body: null,
      constraint: null,
      localX: 0,
      localY: 0,
      grabNormY: 0,
      grabAngle: 0,
      pointerX: 0,
      pointerY: 0,
      targetPointerX: 0,
      targetPointerY: 0,
      centerX: 0,
      centerY: 0,
      trail: []
    };
  }

  function createMotionState() {
    return { reduced: false, frameId: 0, lastTick: 0, angle: 0, angleVel: 0, x: 0, topY: 0 };
  }

  function createRetractState() {
    return { start: 0, fromX: 0, fromY: 0, toX: 0, toY: 0 };
  }

  function HeaderMouseMatter() {
    var root = document.querySelector('[data-header-mouse]');
    var dom;
    if (!root || !window.Matter) return;
    dom = {
      root: root,
      svg: root.querySelector('[data-header-mouse-svg]'),
      paths: root.querySelectorAll('[data-header-mouse-path]'),
      handle: root.querySelector('[data-header-mouse-handle]'),
      img: root.querySelector('[data-header-mouse-image]'),
      tip: root.querySelector('[data-header-mouse-tip]')
    };
    if (!dom.svg || !dom.paths.length || !dom.handle || !dom.img) return;
    this.Matter = window.Matter;
    this.dom = dom;
    this.layout = createLayout();
    this.drag = createDragState();
    this.motion = createMotionState();
    this.retract = createRetractState();
    this.world = { engine: null, body: null, anchor: null };
    this.state = 'idle';
    this.initialized = false;
    this._onPointerDown = this._onPointerDown.bind(this);
    this._onPointerMove = this._onPointerMove.bind(this);
    this._onPointerUp = this._onPointerUp.bind(this);
    this._onResize = this._onResize.bind(this);
    this._onBlur = this._onBlur.bind(this);
    this._tick = this._tick.bind(this);
    this._init();
  }

  HeaderMouseMatter.prototype._init = function () {
    var reducedQuery;
    reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.motion.reduced = reducedQuery.matches;
    if (reducedQuery.addEventListener) {
      reducedQuery.addEventListener('change', function (e) {
        this.motion.reduced = e.matches;
      }.bind(this));
    }
    if (this.dom.img.complete && this.dom.img.naturalWidth) {
      this._setup();
      return;
    }
    this.dom.img.addEventListener('load', this._setup.bind(this), { once: true });
    this.dom.img.addEventListener('error', function () {
      this.dom.root.style.display = 'none';
    }.bind(this), { once: true });
  };

  HeaderMouseMatter.prototype._setup = function () {
    if (this.initialized) return;
    this.initialized = true;
    this._measure();
    this._createWorld();
    this._resetToRest();
    this._renderCable();
    this._show();
    this.dom.handle.addEventListener('pointerdown', this._onPointerDown);
    window.addEventListener('resize', this._onResize);
    window.addEventListener('blur', this._onBlur);
  };

  HeaderMouseMatter.prototype._show = function () {
    this.dom.svg.style.opacity = '1';
    this.dom.handle.style.opacity = '1';
    if (this.dom.tip) this.dom.tip.style.opacity = '1';
  };

  HeaderMouseMatter.prototype._measure = function () {
    var header = document.querySelector('header.header');
    var rect = header ? header.getBoundingClientRect() : { bottom: 0 };
    var handleH = this.dom.handle.offsetHeight;
    var layout = this.layout;
    var renderedW = this.dom.img.offsetWidth || this.dom.handle.offsetWidth;
    if (renderedW) CFG.mouseWidth = renderedW;
    if (!handleH && this.dom.img.naturalWidth && this.dom.img.naturalHeight) {
      handleH = (this.dom.img.naturalHeight / this.dom.img.naturalWidth) * CFG.mouseWidth;
    }
    layout.handleH = handleH || CFG.mouseWidth * 1.36;
    layout.anchorX = window.innerWidth / 2;
    layout.anchorY = rect.bottom - 2;
    layout.restX = layout.anchorX;
    layout.restTopY = layout.anchorY + CFG.restGap;
    layout.restCenterY = layout.restTopY + layout.handleH / 2;
    layout.boundsL = CFG.mouseWidth / 2 + CFG.edgePad;
    layout.boundsR = window.innerWidth - CFG.mouseWidth / 2 - CFG.edgePad;
    layout.boundsTop = layout.anchorY + 4;
    layout.boundsBottom = window.innerHeight * 0.92;
    layout.boundsCenterTop = layout.boundsTop + layout.handleH / 2;
    layout.boundsCenterBottom = layout.boundsBottom + layout.handleH / 2;
  };

  HeaderMouseMatter.prototype._createWorld = function () {
    var Matter = this.Matter;
    var layout = this.layout;
    var bodyW = Math.max(CFG.mouseWidth * 0.58, 52);
    var bodyH = Math.max(layout.handleH * 0.76, 84);
    this.world.engine = Matter.Engine.create({ enableSleeping: false });
    this.world.engine.gravity.x = 0;
    this.world.engine.gravity.y = CFG.physics.gravityY;
    this.world.engine.gravity.scale = CFG.physics.gravityScale;
    this.world.body = Matter.Bodies.rectangle(layout.restX, layout.restCenterY, bodyW, bodyH, {
      density: CFG.physics.bodyDensity,
      frictionAir: CFG.physics.bodyAir,
      restitution: 0.16,
      chamfer: { radius: Math.min(bodyW, bodyH) * 0.18 }
    });
    Matter.Body.setInertia(this.world.body, Infinity);
    this.world.anchor = Matter.Constraint.create({
      pointA: { x: layout.anchorX, y: layout.anchorY },
      bodyB: this.world.body,
      pointB: { x: 0, y: -layout.handleH / 2 + CFG.cableInset },
      length: CFG.cableLength,
      stiffness: CFG.physics.anchorStiffness,
      damping: CFG.physics.anchorDamping
    });
    Matter.World.add(this.world.engine.world, [this.world.body, this.world.anchor]);
  };

  HeaderMouseMatter.prototype._syncMotionPosition = function () {
    this.motion.x = this.world.body.position.x;
    this.motion.topY = this.world.body.position.y - this.layout.handleH / 2;
  };

  HeaderMouseMatter.prototype._setBodyState = function (x, y, velocity) {
    var Matter = this.Matter;
    Matter.Body.setPosition(this.world.body, { x: x, y: y });
    Matter.Body.setVelocity(this.world.body, velocity || { x: 0, y: 0 });
    Matter.Body.setAngularVelocity(this.world.body, 0);
    this._syncMotionPosition();
  };

  HeaderMouseMatter.prototype._resetVisuals = function () {
    this.motion.angle = 0;
    this.motion.angleVel = 0;
    this._applyPosition(this.motion.x, this.motion.topY, 0);
    this._applyImageDepth(0, 0);
  };

  HeaderMouseMatter.prototype._resetToRest = function () {
    this.state = 'idle';
    this.motion.lastTick = 0;
    this.drag.trail = [];
    this._setBodyState(this.layout.restX, this.layout.restCenterY);
    this._resetVisuals();
  };

  HeaderMouseMatter.prototype._applyPosition = function (centerX, topY, rotation) {
    this.dom.handle.style.transform =
      'translate(' + (centerX - CFG.mouseWidth / 2) + 'px,' + topY + 'px) rotate(' + rotation + 'deg)';
  };

  HeaderMouseMatter.prototype._applyImageDepth = function (yaw, pitch) {
    this.dom.img.style.transform =
      'perspective(700px) rotateX(' + pitch + 'deg) rotateY(' + yaw + 'deg)';
  };

  HeaderMouseMatter.prototype._getCablePoint = function (rotation) {
    var radians = (rotation || 0) * Math.PI / 180;
    var localY = -this.layout.handleH / 2 + CFG.cableInset;
    return {
      x: this.motion.x - localY * Math.sin(radians),
      y: this.world.body.position.y + localY * Math.cos(radians)
    };
  };

  HeaderMouseMatter.prototype._renderCable = function (rotation) {
    var layout = this.layout;
    var point = this._getCablePoint(rotation);
    var x = point.x;
    var y = point.y;
    var dx = x - layout.anchorX;
    var dy = y - layout.anchorY;
    var dist = Math.sqrt(dx * dx + dy * dy);
    var stretch = Math.max(0, dist - CFG.cableLength);
    var sag = clamp(10 + stretch * 0.18 + Math.abs(this.world.body.velocity.y) * 5.2, 10, 42);
    var d = 'M' + layout.anchorX + ',' + layout.anchorY +
      ' C' + (layout.anchorX + dx * 0.22) + ',' + (layout.anchorY + dy * 0.22 + sag) +
      ' ' + (layout.anchorX + dx * 0.76) + ',' + (layout.anchorY + dy * 0.76 + sag * 0.45) +
      ' ' + x + ',' + y;
    var i;
    for (i = 0; i < this.dom.paths.length; i++) this.dom.paths[i].setAttribute('d', d);
    this._renderTip(point, rotation);
  };

  HeaderMouseMatter.prototype._renderTip = function (cablePoint, rotation) {
    if (!this.dom.tip) return;
    var tipW = 18;
    var tipH = 16;
    this.dom.tip.style.transform =
      'translate3d(' + (cablePoint.x - tipW / 2) + 'px,' + (cablePoint.y - 4) + 'px,0) rotate(' + (rotation || 0) + 'deg)';
  };

  HeaderMouseMatter.prototype._getDelta = function (now) {
    var dt;
    if (!this.motion.lastTick) {
      this.motion.lastTick = now;
      return CFG.frameMs;
    }
    dt = now - this.motion.lastTick;
    this.motion.lastTick = now;
    return clamp(dt, 12, 25);
  };

  HeaderMouseMatter.prototype._queueFrame = function () {
    if (this.motion.frameId) return;
    this.motion.lastTick = 0;
    this.motion.frameId = requestAnimationFrame(this._tick);
  };

  HeaderMouseMatter.prototype._cancelFrame = function () {
    if (!this.motion.frameId) return;
    cancelAnimationFrame(this.motion.frameId);
    this.motion.frameId = 0;
    this.motion.lastTick = 0;
  };

  HeaderMouseMatter.prototype._togglePointerListeners = function (active) {
    var method = active ? 'addEventListener' : 'removeEventListener';
    window[method]('pointermove', this._onPointerMove);
    window[method]('pointerup', this._onPointerUp);
    window[method]('pointercancel', this._onPointerUp);
  };

  HeaderMouseMatter.prototype._clearDragConstraint = function () {
    if (this.drag.constraint) {
      this.Matter.World.remove(this.world.engine.world, this.drag.constraint);
      this.drag.constraint = null;
    }
    if (this.drag.body) {
      this.Matter.World.remove(this.world.engine.world, this.drag.body);
      this.drag.body = null;
    }
  };

  HeaderMouseMatter.prototype._releasePointerCapture = function (e) {
    try {
      if (e && typeof e.pointerId !== 'undefined') this.dom.handle.releasePointerCapture(e.pointerId);
    } catch (err) {
    }
  };

  HeaderMouseMatter.prototype._applyActiveForces = function (dt) {
    var Matter = this.Matter;
    var body = this.world.body;
    var layout = this.layout;
    var drag = this.drag;
    var centerForce = this.state === 'dragging' ? CFG.physics.dragCenterForce : CFG.physics.centerForce;
    var frame = clamp(dt / CFG.frameMs, 0.75, 1.5);
    var pointerFollow = 1 - Math.pow(1 - CFG.physics.pointerFollow, frame);
    Matter.Body.applyForce(body, body.position, {
      x: (layout.restX - body.position.x) * centerForce,
      y: (layout.restCenterY - body.position.y) * centerForce
    });
    if (this.state !== 'dragging') return;
    drag.pointerX += (drag.targetPointerX - drag.pointerX) * pointerFollow;
    drag.pointerY += (drag.targetPointerY - drag.pointerY) * pointerFollow;
    Matter.Body.setPosition(drag.body, { x: drag.pointerX, y: drag.pointerY });
    Matter.Body.applyForce(body, body.position, {
      x: 0,
      y: -Math.abs(drag.centerX - body.position.x) * CFG.physics.pointerLift
    });
  };

  HeaderMouseMatter.prototype._clampBody = function () {
    var Matter = this.Matter;
    var body = this.world.body;
    var layout = this.layout;
    var x = body.position.x;
    var y = body.position.y;
    var vx = body.velocity.x;
    var vy = body.velocity.y;
    var changed = false;
    if (x < layout.boundsL) {
      x = layout.boundsL;
      vx = Math.abs(vx) * 0.18;
      changed = true;
    } else if (x > layout.boundsR) {
      x = layout.boundsR;
      vx = -Math.abs(vx) * 0.18;
      changed = true;
    }
    if (y < layout.boundsCenterTop) {
      y = layout.boundsCenterTop;
      vy = Math.abs(vy) * 0.14;
      changed = true;
    } else if (y > layout.boundsCenterBottom) {
      y = layout.boundsCenterBottom;
      vy = -Math.abs(vy) * 0.18;
      changed = true;
    }
    if (!changed) return;
    Matter.Body.setPosition(body, { x: x, y: y });
    Matter.Body.setVelocity(body, { x: vx, y: vy });
  };

  HeaderMouseMatter.prototype._renderBody = function (isDragging, dt) {
    var frame = clamp(dt / CFG.frameMs, 0.75, 1.5);
    var body = this.world.body;
    var drag = this.drag;
    var dx = this.motion.x - this.layout.anchorX;
    var dy = this.motion.topY + CFG.cableInset - this.layout.anchorY;
    var cableLean = Math.atan2(dx, Math.max(dy, 1)) * 57.2958;
    var vx = body.velocity.x;
    var vy = body.velocity.y;
    var targetAngle;
    var yaw;
    var pitch;
    if (isDragging) {
      var pFromPivotX = drag.pointerX - this.motion.x;
      var pFromPivotY = drag.pointerY - this.motion.topY;
      var pDist = Math.sqrt(pFromPivotX * pFromPivotX + pFromPivotY * pFromPivotY);
      var pullTarget = 0;
      var grip = drag.grabNormY * drag.grabNormY;
      if (pDist > 5) {
        pullTarget = Math.atan2(pFromPivotX, Math.max(pFromPivotY, 1)) * 57.2958 - drag.grabAngle;
      }
      targetAngle = clamp(
        pullTarget * grip * 0.72 + vx * grip * 4.25 + cableLean * (1 - grip * 0.6) * 0.38,
        -CFG.maxRotation,
        CFG.maxRotation
      );
    } else {
      targetAngle = clamp(cableLean * 0.88 + vx * 7.4, -CFG.maxRotation, CFG.maxRotation);
    }
    this.motion.angleVel = (this.motion.angleVel + (targetAngle - this.motion.angle) * CFG.angle.pull * frame) *
      Math.pow(CFG.angle.damping, frame);
    this.motion.angle = clamp(this.motion.angle + this.motion.angleVel * frame, -CFG.maxRotation, CFG.maxRotation);
    this._applyPosition(this.motion.x, this.motion.topY, this.motion.angle);
    yaw = clamp((-this.motion.angle * 0.75) + vx * -2.1, -9, 9);
    pitch = clamp((vy * -1.55) - Math.abs(this.motion.angle) * 0.12, -6, 6);
    this._applyImageDepth(yaw, pitch);
    this._renderCable(this.motion.angle);
  };

  HeaderMouseMatter.prototype._isSettled = function () {
    var dx = this.world.body.position.x - this.layout.restX;
    var dy = this.world.body.position.y - this.layout.restCenterY;
    return this.world.body.speed < CFG.settle.speed &&
      Math.sqrt(dx * dx + dy * dy) < CFG.settle.distance &&
      Math.abs(this.motion.angle) < CFG.settle.angle &&
      Math.abs(this.motion.angleVel) < CFG.settle.angleVelocity;
  };

  HeaderMouseMatter.prototype._updatePointer = function (e) {
    var drag = this.drag;
    var layout = this.layout;
    var now;
    if (this.state !== 'dragging') return;
    drag.centerX = clamp(e.clientX - drag.localX, layout.boundsL, layout.boundsR);
    drag.centerY = clamp(e.clientY - drag.localY, layout.boundsCenterTop, layout.boundsCenterBottom);
    drag.targetPointerX = drag.centerX + drag.localX;
    drag.targetPointerY = drag.centerY + drag.localY;
    if (!drag.trail.length) {
      drag.pointerX = drag.targetPointerX;
      drag.pointerY = drag.targetPointerY;
    }
    now = performance.now();
    drag.trail.push({ x: drag.centerX, y: drag.centerY, t: now });
    if (drag.trail.length > 6) drag.trail.shift();
  };

  HeaderMouseMatter.prototype._computeReleaseVelocity = function () {
    var trail = this.drag.trail;
    var Matter = this.Matter;
    var first;
    var last;
    var dt;
    if (trail.length < 2) {
      this.drag.trail = [];
      return;
    }
    first = trail[0];
    last = trail[trail.length - 1];
    dt = (last.t - first.t) || CFG.frameMs;
    Matter.Body.setVelocity(this.world.body, {
      x: clamp(
        this.world.body.velocity.x + ((last.x - first.x) / dt * CFG.frameMs) * 0.62,
        -CFG.physics.maxReleaseVelocity,
        CFG.physics.maxReleaseVelocity
      ),
      y: clamp(
        this.world.body.velocity.y + ((last.y - first.y) / dt * CFG.frameMs) * 0.62,
        -CFG.physics.maxReleaseVelocity,
        CFG.physics.maxReleaseVelocity
      )
    });
    this.drag.trail = [];
  };

  HeaderMouseMatter.prototype._beginReducedRetract = function () {
    this.state = 'retracting';
    this.retract.start = performance.now();
    this.retract.fromX = this.world.body.position.x;
    this.retract.fromY = this.world.body.position.y;
    this.retract.toX = this.layout.restX;
    this.retract.toY = this.layout.restCenterY;
    this._queueFrame();
  };

  HeaderMouseMatter.prototype._stepReducedRetract = function (now) {
    var t = clamp((now - this.retract.start) / CFG.reducedMs, 0, 1);
    var eased = easeRetract(t);
    var x = this.retract.fromX + (this.retract.toX - this.retract.fromX) * eased;
    var y = this.retract.fromY + (this.retract.toY - this.retract.fromY) * eased;
    var dx;
    var maxDx;
    var rotation;
    this._setBodyState(x, y);
    dx = x - this.layout.restX;
    maxDx = Math.max(this.layout.boundsR - this.layout.restX, this.layout.restX - this.layout.boundsL, 1);
    rotation = clamp(dx * (CFG.maxRotation / maxDx), -CFG.maxRotation, CFG.maxRotation) * (1 - eased);
    this._applyPosition(this.motion.x, this.motion.topY, rotation);
    this._applyImageDepth(clamp(rotation * -0.55, -8, 8), clamp(-Math.abs(rotation) * 0.18, -5, 5));
    this._renderCable(rotation);
    if (t < 1) {
      this.motion.frameId = requestAnimationFrame(this._tick);
      return;
    }
    this._resetToRest();
    this._cancelFrame();
  };

  HeaderMouseMatter.prototype._endDrag = function (e) {
    this._releasePointerCapture(e);
    this._togglePointerListeners(false);
    this._clearDragConstraint();
  };

  HeaderMouseMatter.prototype._onPointerDown = function (e) {
    var Matter = this.Matter;
    var topY;
    if (!this.world.body) return;
    e.preventDefault();
    this._cancelFrame();
    this._togglePointerListeners(false);
    this._clearDragConstraint();
    this.state = 'dragging';
    this.drag.trail = [];
    this.motion.angleVel = 0;
    topY = this.world.body.position.y - this.layout.handleH / 2;
    this.drag.localX = e.clientX - this.world.body.position.x;
    this.drag.localY = e.clientY - this.world.body.position.y;
    this.drag.grabNormY = clamp((e.clientY - topY) / this.layout.handleH, 0, 1);
    this.drag.grabAngle = Math.sqrt(
      (e.clientX - this.world.body.position.x) * (e.clientX - this.world.body.position.x) +
      (e.clientY - topY) * (e.clientY - topY)
    ) > 3
      ? Math.atan2(e.clientX - this.world.body.position.x, Math.max(e.clientY - topY, 1)) * 57.2958
      : 0;
    this.drag.body = Matter.Bodies.circle(e.clientX, e.clientY, 2, { isStatic: true });
    this.drag.constraint = Matter.Constraint.create({
      bodyA: this.drag.body,
      bodyB: this.world.body,
      pointB: { x: this.drag.localX, y: this.drag.localY },
      length: 0,
      stiffness: CFG.physics.dragStiffness,
      damping: CFG.physics.dragDamping
    });
    Matter.World.add(this.world.engine.world, [this.drag.body, this.drag.constraint]);
    try {
      this.dom.handle.setPointerCapture(e.pointerId);
    } catch (err) {
    }
    this._togglePointerListeners(true);
    this._updatePointer(e);
    this.drag.pointerX = this.drag.targetPointerX;
    this.drag.pointerY = this.drag.targetPointerY;
    this._queueFrame();
  };

  HeaderMouseMatter.prototype._onPointerMove = function (e) {
    this._updatePointer(e);
  };

  HeaderMouseMatter.prototype._onPointerUp = function (e) {
    this._endDrag(e);
    if (this.state !== 'dragging') return;
    if (this.motion.reduced) {
      this._beginReducedRetract();
      return;
    }
    this._computeReleaseVelocity();
    this.state = 'springing';
    this._queueFrame();
  };

  HeaderMouseMatter.prototype._tick = function (now) {
    var dt;
    this.motion.frameId = 0;
    if (!this.world.body) return;
    if (this.state === 'retracting') {
      this._stepReducedRetract(now);
      return;
    }
    if (this.state !== 'dragging' && this.state !== 'springing') return;
    dt = this._getDelta(now);
    this._applyActiveForces(dt);
    this.Matter.Engine.update(this.world.engine, dt);
    this._clampBody();
    this._syncMotionPosition();
    this._renderBody(this.state === 'dragging', dt);
    if (this.state === 'springing' && this._isSettled()) {
      this._resetToRest();
      return;
    }
    this.motion.frameId = requestAnimationFrame(this._tick);
  };

  HeaderMouseMatter.prototype._onResize = function () {
    if (!this.initialized) return;
    this._togglePointerListeners(false);
    this._clearDragConstraint();
    this._cancelFrame();
    this._measure();
    this.world.anchor.pointA.x = this.layout.anchorX;
    this.world.anchor.pointA.y = this.layout.anchorY;
    this.world.anchor.length = CFG.cableLength;
    this.world.anchor.pointB.y = -this.layout.handleH / 2 + CFG.cableInset;
    this._resetToRest();
    this._renderCable();
  };

  HeaderMouseMatter.prototype._onBlur = function () {
    if (this.state === 'dragging') this._onPointerUp();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      new HeaderMouseMatter();
    });
  } else {
    new HeaderMouseMatter();
  }
})();
